module.exports = __webpack_public_path__ + "static/img/types_ls.33200beb.png";